import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { AuthUserModel } from 'src/app/auth/auth-user.model';

@Component({
  selector: 'legal-notice-dialog',
  templateUrl: './legal-notice-dialog.component.html',
  styleUrls: ['./legal-notice-dialog.component.scss']
})
export class LegalNoticeDialogComponent implements OnInit {

  faTimes = faTimes;
  legalNoticeContent: string = null;

  constructor(
    public dialogRef: MatDialogRef<LegalNoticeDialogComponent>,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.legalNoticeContent = this.translateService.instant('app.legal-notice-dialog.content');
  }

  onOkClick(): void {
    this.dialogRef.close(true);
  }
}
